import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { createCollaborator, updateCollaborator } from "../services/roleApi";
import toast from "react-hot-toast";

const NewCollaboratorModal = ({ show, onClose, onCreated, merchantId, editingCollab }) => {
  const authUser = JSON.parse(sessionStorage.getItem("authUser"));
  
  const [form, setForm] = useState({ fullName: "", email: "", role: "" });

  useEffect(() => {
    if (editingCollab) {
      setForm({
        fullName: editingCollab.fullName || "",
        email: editingCollab.email || "",
        role: editingCollab.role || "",
      });
    } else {
      setForm({ fullName: "", email: "", role: "" });
    }
  }, [editingCollab]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    try {
      if (editingCollab) {

        // UPDATE
        await updateCollaborator(editingCollab.id, authUser?.token, form);
        toast.success("Collaborateur modifié avec succès");
      } else {
        const requestBody = {
          "fullName": form?.fullName,
          "email": form?.email,
          "password": form?.password
        }
        // CREATE
        await createCollaborator(merchantId, authUser?.token, requestBody);
        toast.success("Collaborateur ajouté avec succès");
      }
      onCreated();
      onClose();
    } catch (err) {
      console.error(err);
      toast.error("Erreur lors de l’opération ❌");
    }
  };

  return (
      <Modal
        show={show} onHide={onClose} centered className="custom-modaL">
      <Modal.Body>
         <div style={{ padding: "0 40px" }}>
        <Form>
            <div className="titles mb-5">
          {editingCollab ? "Modifier le collaborateur" : "Nouveau collaborateur"}
            </div>
          <Form.Group className="mb-3">
            <Form.Label className="labels">Nom complet</Form.Label>
            <Form.Control
              type="text"
              name="fullName"
              value={form.fullName}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="labels">Email</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="labels">Mot de passe</Form.Label>
            <Form.Control
              type="password"
              name="password"
              className="inputs"
              value={form.password}
               onChange={handleChange}
            />
          </Form.Group>

        </Form>
        <Button className="buttonSui mb-4" style={{width:"422px",height:'40px',padding:'0px 80px'}}  onClick={handleSubmit}>
          {editingCollab ? "Modifier" : "Ajouter"}
        </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default NewCollaboratorModal;
